module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product28-c84ec0d8a1ff9c42821a1739da93b943.jpg";